import React from "react";
import { Layout, Menu, Avatar, Button, Image } from "antd";
import "../App.css";
import {
  UserOutlined,
  ShoppingCartOutlined,
  DashboardOutlined,
  EditOutlined,
  HomeOutlined,
  PictureOutlined,
  CommentOutlined,
  FileTextOutlined,
  ProductOutlined,
  FormOutlined,
  ProfileOutlined,
  RadarChartOutlined,
  IssuesCloseOutlined,
  ContactsOutlined,
  LogoutOutlined,
  SettingOutlined,
  BellOutlined,
  MailOutlined,
  MessageOutlined,
  TruckOutlined,
  AppstoreOutlined,
  TagsOutlined,
  CarOutlined,
  FlagOutlined,
  SafetyOutlined,
  TeamOutlined,
  SolutionOutlined,
  NotificationOutlined,
  FolderOutlined,
  BookOutlined,
  FileSyncOutlined,
  ControlOutlined,
  CommentOutlined as CommentIcon,
  IdcardOutlined,
  BankOutlined,
  FileExcelOutlined,
  FolderOpenOutlined,
  ShopOutlined,
  GlobalOutlined,
  SafetyCertificateOutlined,
  PercentageOutlined,
  CalendarOutlined,
  BarChartOutlined,
  CustomerServiceOutlined,
  SwapOutlined, // برای ری‌دایرکت‌ها
} from "@ant-design/icons";
import { useTheme } from "../contexts/ThemeContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getCurrentUser, logout } from "../services/auth";
import logo from "../images/sellerbanner.jpg";

const { Sider } = Layout;
const { SubMenu } = Menu;

const Sidebar = ({ showModal, isMobile, onCloseMobile }) => {
  const { isDarkMode } = useTheme();
  const location = useLocation();
  const user = getCurrentUser();
  const navigate = useNavigate();

  const handleMenuClick = (path) => {
    if (isMobile) {
      onCloseMobile?.();
    }
    navigate(path);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <Sider
      width={250}
      theme={isDarkMode ? "dark" : "light"}
      className={`h-screen ${isMobile ? "relative" : "fixed"} custom-scrollbar`}
      style={{
        borderRight: `1px solid ${isDarkMode ? "#303030" : "#f0f0f0"}`,
        overflowY: "auto",
      }}
    >
      <div className="flex items-center justify-center flex-col p-6">
        <img src={logo} className="w-[120px] " alt="لوگو" />
      </div>

      <div style={{ overflowY: "auto", maxHeight: "calc(100vh - 200px)" }}>
        <Menu
          theme={isDarkMode ? "dark" : "light"}
          mode="inline"
          selectedKeys={[location.pathname]}
          defaultOpenKeys={["صفحه-اصلی", "محصول", "سفارشات"]}
        >
          <Menu.Item key="/" icon={<DashboardOutlined />}>
            <Link to="/">داشبورد</Link>
          </Menu.Item>

          <SubMenu key="product" icon={<AppstoreOutlined />} title="محصولات">
            <Menu.Item key="/products" icon={<ShoppingCartOutlined />}>
              <Link to="/products">محصولات</Link>
            </Menu.Item>
            <Menu.Item key="/productsVariation" icon={<TagsOutlined />}>
              <Link to="/productsVariation">تنوع محصولات</Link>
            </Menu.Item>
            <Menu.Item key="/categories" icon={<FolderOpenOutlined />}>
              <Link to="/categories">دسته‌بندی</Link>
            </Menu.Item>

            <Menu.Item key="/brands" icon={<FlagOutlined />}>
              <Link to="/brands">برند</Link>
            </Menu.Item>
          </SubMenu>

          <SubMenu
            key="taksonami"
            icon={<RadarChartOutlined />}
            title="تاکسونامی"
          >
            <Menu.Item key="/car" icon={<CarOutlined />}>
              <Link to="/car">خودروها</Link>
            </Menu.Item>
            <Menu.Item key="/car_type" icon={<CarOutlined />}>
              <Link to="/car_type">تیپ خودروها</Link>
            </Menu.Item>
            <Menu.Item key="/seller" icon={<ShopOutlined />}>
              <Link to="/seller">تامین کننده</Link>
            </Menu.Item>
            <Menu.Item key="/country" icon={<GlobalOutlined />}>
              <Link to="/country">کشورها</Link>
            </Menu.Item>
            <Menu.Item key="/guarantee" icon={<SafetyCertificateOutlined />}>
              <Link to="/guarantee">گارانتی</Link>
            </Menu.Item>
          </SubMenu>

          <Menu.Item key="/discount" icon={<PercentageOutlined />}>
            <Link to="/discount">تخفیف‌ها</Link>
          </Menu.Item>

          <Menu.Item key="/pages" icon={<FileTextOutlined />}>
            <Link to="/pages">صفحه‌ساز شخصی</Link>
          </Menu.Item>

          <SubMenu
            key="/ticket"
            icon={<SolutionOutlined />}
            title="درخواست‌ها"
          >
            <Menu.Item
              key="/ticket/international_request"
              icon={<GlobalOutlined />}
            >
              <Link to="/ticket/international_request">
                درخواست‌های بین المللی
              </Link>
            </Menu.Item>
            <Menu.Item
              key="/ticket"
              icon={<FileSyncOutlined />}
            >
              <Link to="/ticket"> درخواست پشتیبانی</Link>
            </Menu.Item>
            <Menu.Item
              key="/ticket/branch_obtain"
              icon={<FileSyncOutlined />}
            >
              <Link to="/ticket/branch_obtain "> فروشنده شو</Link>
            </Menu.Item>
            <Menu.Item
              key="/ticket/part_request"
              icon={<FileSyncOutlined />}
            >
              <Link to="/ticket/part_request"> درخواست قطعه</Link>
            </Menu.Item>
            <Menu.Item
              key="/ticket/email_subscription"
              icon={<FileSyncOutlined />}
            >
              <Link to="/ticket/email_subscription"> خبرنامه</Link>
            </Menu.Item>
          </SubMenu>

          <SubMenu key="orders" icon={<ShoppingCartOutlined />} title="سفارشات">
            <Menu.Item key="/orders" icon={<ShoppingCartOutlined />}>
              <Link to="/orders">سفارشات</Link>
            </Menu.Item>

            <Menu.Item key="/open-orders" icon={<ShoppingCartOutlined />}>
              <Link to="/open-orders">سفارشات باز</Link>
            </Menu.Item>

            <Menu.Item key="/call_center" icon={<CustomerServiceOutlined />}>
              <Link to="/call_center">کال سنتر</Link>
            </Menu.Item>
          </SubMenu>

          <SubMenu key="report" icon={<BarChartOutlined />} title="گزارشات">
            <Menu.Item key="/product-report" icon={<ShoppingCartOutlined />}>
              <Link to="/product-report">تغییرات محصول</Link>
            </Menu.Item>

            <Menu.Item key="/price-report" icon={<CustomerServiceOutlined />}>
              <Link to="/price-report"> افزایش قیمت</Link>
            </Menu.Item>
          </SubMenu>

          <Menu.Item key="/excel" icon={<FileExcelOutlined />}>
            <Link to="/excel">فایل‌های اکسل</Link>
          </Menu.Item>

          <Menu.Item key="/event" icon={<CalendarOutlined />}>
            <Link to="/event">رویدادها</Link>
          </Menu.Item>

          <Menu.Item key="/carrier" icon={<TruckOutlined />}>
            <Link to="/carrier">حامل‌ها</Link>
          </Menu.Item>

          <Menu.Item key="/gallery" icon={<PictureOutlined />}>
            <Link to="/gallery">گالری</Link>
          </Menu.Item>
          <Menu.Item key="/comments" icon={<MessageOutlined />}>
            <Link to="/comments">نظرات</Link>
          </Menu.Item>

          <Menu.Item key="/redirects" icon={<SwapOutlined />}>
            <Link to="/redirects">ری‌دایرکت‌ها</Link>
          </Menu.Item>

          <Menu.Item key="/users" icon={<TeamOutlined />}>
            <Link to="/users">مدیریت کاربران</Link>
          </Menu.Item>

          <Menu.Item key="/roles" icon={<IdcardOutlined />}>
            <Link to="/roles">مدیریت نقش‌ها</Link>
          </Menu.Item>

          <SubMenu key="setting" icon={<SettingOutlined />} title="تنظیمات">
            <Menu.Item key="/site_setting" icon={<ControlOutlined />}>
              <Link to="/site_setting">تنظیمات سایت</Link>
            </Menu.Item>
            <Menu.Item key="/comment_setting" icon={<CommentOutlined />}>
              <Link to="/comment_setting"> تنظیمات دیدگاه</Link>
            </Menu.Item>
            <Menu.Item key="/seo_setting" icon={<BarChartOutlined />}>
              <Link to="/seo_setting"> تنظیمات سئو</Link>
            </Menu.Item>
            <Menu.Item key="/category_setting" icon={<FolderOutlined />}>
              <Link to="/category_setting"> تنظیمات دسته‌بندی</Link>
            </Menu.Item>
          </SubMenu>

          <Menu.Item
            className="text-red-600"
            danger
            key="logout"
            icon={<LogoutOutlined />}
            onClick={handleLogout}
          >
            خروج
          </Menu.Item>
        </Menu>
      </div>
    </Sider>
  );
};

export default Sidebar;